import { create } from "zustand";
import type { WSEvent } from "@/lib/types";

interface EventsState {
  connected: boolean;
  log: WSEvent[];
  maxLog: number;
  addEvent: (e: WSEvent) => void;
  setConnected: (v: boolean) => void;
  clear: () => void;
  /** subscribers by account_id for live-refresh */
  listeners: Map<string, Set<(e: WSEvent) => void>>;
  subscribe: (accountId: string | "*", cb: (e: WSEvent) => void) => () => void;
}

export const useEvents = create<EventsState>((set, get) => ({
  connected: false,
  log: [],
  maxLog: 500,
  listeners: new Map(),
  setConnected: (connected) => set({ connected }),
  addEvent: (e) => {
    const evt: WSEvent = { ...e, receivedAt: Date.now() };
    const { log, maxLog, listeners } = get();
    const next = [evt, ...log].slice(0, maxLog);
    set({ log: next });
    listeners.get("*")?.forEach((cb) => cb(evt));
    if (evt.account_id) listeners.get(evt.account_id)?.forEach((cb) => cb(evt));
  },
  clear: () => set({ log: [] }),
  subscribe: (accountId, cb) => {
    const { listeners } = get();
    let set_ = listeners.get(accountId);
    if (!set_) {
      set_ = new Set();
      listeners.set(accountId, set_);
    }
    set_.add(cb);
    return () => {
      set_!.delete(cb);
      if (set_!.size === 0) listeners.delete(accountId);
    };
  },
}));
